module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//light.png?v=854c283c";